// Hides BF deal tiles outside their start/end window on the client. Liquid already filters
// them, but cached storefront pages can be served after a tile expired or before it started.

const isOutsideWindow = (tile: HTMLElement, nowSeconds: number) => {
  const starts = Number(tile.dataset.starts || 0);
  const expires = Number(tile.dataset.expires || 0);
  if (starts > 0 && nowSeconds < starts) return true;
  if (expires > 0 && nowSeconds >= expires) return true;
  return false;
};

export const initBfDealGrid = (root: ParentNode = document) => {
  // The theme editor keeps out-of-window tiles visible (with a hint) for editing
  if ((window as Window & { Shopify?: { designMode?: boolean } }).Shopify?.designMode) return;

  const nowSeconds = Date.now() / 1000;
  const tiles = root.querySelectorAll<HTMLElement>("[data-bf-deal-tile][data-starts], [data-bf-deal-tile][data-expires]");
  for (const tile of Array.from(tiles)) {
    if (isOutsideWindow(tile, nowSeconds)) tile.remove();
  }
};
